import React, { useEffect, useState } from 'react';
import { auth, db } from './firebase';
import { signOut, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { Link, useNavigate } from 'react-router-dom';
function AccountPortal() {
    const [role, setRole] = useState('');
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            if (currentUser) {
                setUser(currentUser);
                const docRef = doc(db, 'roles', currentUser.uid);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    setRole(docSnap.data().role || 'unknown');
                } else {
                    setRole('unknown');
                }
            } else {
                navigate('/login'); // 如果無login就踢返去login
            }
            setLoading(false);
        });

        return () => unsubscribe(); // cleanup listener
    }, [navigate]);

    const handleLogout = async () => {
        await signOut(auth);
        navigate('/login');
    };

    if (loading || !user) return <div className="p-6">Loading...</div>;

    return (
        <div className="p-6 font-sans">
            <h2 className="text-2xl font-bold mb-4">👤 Account Portal</h2>
            <Link to="/dashboard" className="text-blue-600 hover:underline">
                ← Back to Dashboard
            </Link>
            <p><strong>Email:</strong> {user.email}</p>
            <p><strong>UID:</strong> {user.uid}</p>
            <p><strong>Role:</strong> {role}</p>

            <div className="mt-4 space-x-4">
                {role === 'admin' ? (
                    <>
                        <button
                            onClick={() => navigate('/allcalendar')}
                            className="bg-blue-600 text-white px-4 py-2 rounded"
                        >
                            Go to All Calendar
                        </button>

                        <Link to="/admin/accounts" className="text-blue-600 hover:underline">
                            ⚙️ Manage Accounts
                        </Link>
                    </>
                ) : (
                    <button
                        onClick={() => navigate('/studentcalendar')}
                        className="bg-blue-600 text-white px-4 py-2 rounded"
                    >
                        Go to Student Calendar
                    </button>
                )}

                <button
                    onClick={handleLogout}
                    className="bg-red-500 text-white px-4 py-2 rounded"
                >
                    Logout
                </button>
            </div>
        </div>
    );
}

export default AccountPortal;
